import { useMemo } from "react";
import { useTeamContext } from "domains/teams/contexts/TeamProvider";
import { useGetModelPresetsByModelIdQuery } from "infra/api/generated/api";

import { skipToken } from "@reduxjs/toolkit/dist/query";

export default function usePresets({ modelId }: { modelId?: string }) {
  const { selectedProject } = useTeamContext();

  const { currentData: modelPresets } = useGetModelPresetsByModelIdQuery(
    modelId
      ? {
          modelId,
          projectId: selectedProject.id,
        }
      : skipToken
  );

  const defaultPreset = useMemo(
    () => modelPresets?.presets?.find((preset) => preset.isDefault),
    [modelPresets?.presets]
  );

  return {
    presets: modelPresets?.presets ?? [],
    defaultPreset,
  };
}
